/** Persistance légère du flux live/notes (colonnes workouts retirées côté DB). */

const KEY = (workoutId) => `athleos_workout_live_${workoutId}`;

/** @returns {{ startedAt?: string, completedAt?: string } | null} */
export function readWorkoutLiveSession(workoutId) {
  if (typeof window === "undefined" || !workoutId) return null;
  try {
    const raw = window.sessionStorage.getItem(KEY(workoutId));
    if (!raw) return null;
    const o = JSON.parse(raw);
    if (!o || typeof o !== "object") return null;
    return {
      startedAt: typeof o.startedAt === "string" ? o.startedAt : undefined,
      completedAt: typeof o.completedAt === "string" ? o.completedAt : undefined,
    };
  } catch {
    return null;
  }
}

export function writeWorkoutLiveStarted(workoutId, startedAt) {
  if (typeof window === "undefined" || !workoutId) return;
  const prev = readWorkoutLiveSession(workoutId) || {};
  window.sessionStorage.setItem(
    KEY(workoutId),
    JSON.stringify({ ...prev, startedAt: startedAt || prev.startedAt || new Date().toISOString() })
  );
}

export function writeWorkoutLiveCompleted(workoutId, completedAt) {
  if (typeof window === "undefined" || !workoutId) return;
  const prev = readWorkoutLiveSession(workoutId) || {};
  const startedAt = prev.startedAt || new Date().toISOString();
  window.sessionStorage.setItem(
    KEY(workoutId),
    JSON.stringify({
      startedAt,
      completedAt: completedAt || new Date().toISOString(),
    })
  );
}

export function clearWorkoutLiveSession(workoutId) {
  if (typeof window === "undefined" || !workoutId) return;
  try {
    window.sessionStorage.removeItem(KEY(workoutId));
  } catch {
    /* ignore */
  }
}

export function isWorkoutLiveCompleted(workoutId) {
  const s = readWorkoutLiveSession(workoutId);
  return Boolean(s?.completedAt);
}

const PAUSED_KEY_PREFIX = "athleos_workout_live_paused_";
const PAUSED_KEY = (workoutId) => `${PAUSED_KEY_PREFIX}${workoutId}`;

/**
 * Persiste la position exacte d'une séance en pause (localStorage — survit au refresh/verrouillage).
 * snapshot = { sectionIdx, exerciseIdx, setIdx, completedSets, exerciseActuals, exerciseNotes, pausedAt, ... }
 */
export function writeWorkoutLivePaused(workoutId, snapshot) {
  if (typeof window === "undefined" || !workoutId || !snapshot) return;
  try {
    window.localStorage.setItem(PAUSED_KEY(workoutId), JSON.stringify(snapshot));
  } catch {
    /* ignore */
  }
}

/** @returns {object | null} */
export function readWorkoutLivePaused(workoutId) {
  if (typeof window === "undefined" || !workoutId) return null;
  try {
    const raw = window.localStorage.getItem(PAUSED_KEY(workoutId));
    if (!raw) return null;
    const o = JSON.parse(raw);
    if (!o || typeof o !== "object") return null;
    return o;
  } catch {
    return null;
  }
}

export function clearWorkoutLivePaused(workoutId) {
  if (typeof window === "undefined" || !workoutId) return;
  try {
    window.localStorage.removeItem(PAUSED_KEY(workoutId));
  } catch {
    /* ignore */
  }
}

/** Scanne le localStorage pour la séance en pause la plus récente. @returns {{ workoutId: string, snapshot: object } | null} */
export function findPausedWorkoutLive() {
  if (typeof window === "undefined") return null;
  try {
    let best = null;
    for (let i = 0; i < window.localStorage.length; i++) {
      const key = window.localStorage.key(i);
      if (!key || !key.startsWith(PAUSED_KEY_PREFIX)) continue;
      const workoutId = key.slice(PAUSED_KEY_PREFIX.length);
      if (!workoutId) continue;
      const raw = window.localStorage.getItem(key);
      if (!raw) continue;
      let snapshot;
      try {
        snapshot = JSON.parse(raw);
      } catch {
        continue;
      }
      if (!snapshot || typeof snapshot !== "object") continue;
      if (!best || String(snapshot.pausedAt || "") > String(best.snapshot.pausedAt || "")) {
        best = { workoutId, snapshot };
      }
    }
    return best;
  } catch {
    return null;
  }
}
